import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-working-orders',
  templateUrl: './working-orders.component.html',
  styleUrls: ['./working-orders.component.css']
})
export class WorkingOrdersComponent implements OnInit {
    ok;

    public itemsListActivities: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.ok = this.stateService.getStateParams()['ok'];
    }

    private async loadActivities() {
        if (!!this.ok) {
            this.itemsListActivities = await this.datatask.Post(27, {
                cust_name: 'ALL',
                cust_no: '0',
                project_keyno: '0',
                ok: this.ok
            });
        }
    }

    private async init() {
        this.loadActivities();
    }

    ngOnInit() {
        this.init();
    }
}
